import React, {useEffect, useState, useRef} from 'react';
import {connect} from 'react-redux';
import actions from '../../../redux/actions';
import icSearch from '../../../images/ic_search.png';
import '../AffiliateList/AffiliateList.scss';
import './AttentionList.scss';
import TableHeader from '../../../common/components/ItemTable/TableHeader';
import TableRow from '../../../common/components/ItemTable/TableRow';
import ListPaginator from '../../../common/components/ListPaginator/ListPaginator';

import Loading from '../../../common/components/Loading/Loading';
import CustomAlert from '../../../common/components/Alert/CustomAlert';
import Ebutton from '../../../common/components/Ebutton/Ebutton';
import AttentionDetailsModal from '../AttentionDetailsModal/AttentionDetailsModal';
import NavBefore from '../../../common/components/NavBefore/NavBefore';
import {useHistory} from 'react-router';
/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */

const seeDetailButton = (attention, handleClick) => {
    return (
        <Ebutton classNameButton="ul-btn"
            onClick={() => handleClick(attention)}
            text={'Ver mas'}
        />
    );
};

const AttentionList = ({
                        name,
                        attentions,
                        attentionsListConfig,
                        getAttentionsState,
                        getAttentions,
                        selectedAffiliate,
                        setListConfig,
                        switchOfUser,
                        setSelectedAttention,
                        showSidebar,
}) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = (attention) => {
        setShowModal(true);
        setSelectedAttention(attention);
    };

    const listData = [
        {title: 'FECHA', att: 'date'},
        {title: 'SEDE', att: 'branch'},
        {title: 'CONSULTA', att: 'query'},
        {title: 'COPAGO', att: 'copay'},
        {title: 'OTROS DATOS ?', component: () => ('XXXXXXX')},
        {title: '', component: (attention)=>seeDetailButton(attention, handleClick)},
    ];

    // const history = useHistory();

    // const [search, setSearch] = useState('');

    const [currentPage, setCurrentPage] = useState(-1);
    const pageQuantity = Math.ceil(attentions?.total/attentionsListConfig?.size);

    /*
    const pushPage = (name) => {
        history.push(name);
    };
    */

    const isInitialMount = useRef(true);

    useEffect(()=>{
        if ( !isInitialMount.current ) {
            setListConfig( {
                list: 'attentionsListConfig',
                config: {page: currentPage},
            } );
            getAttentions();
        }
        isInitialMount.current = false;
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect( ()=>{
        if ( currentPage >= pageQuantity && pageQuantity>0 ) setCurrentPage( pageQuantity-1 );
        // eslint-disable-next-line
    }, [attentions] );

    useEffect(() => {
        switchOfUser('Historial atenciones');
        setCurrentPage( attentionsListConfig?.page ?? 1 );
        // eslint-disable-next-line
    }, []);

    /*
    const sortList = (param)=>{
        setListConfig( {
            list: 'adminListConfig',
            config: {orderBy: param},
        } );
        getUsers();
    };

    const handleSearch = () => {
        setListConfig( {
            list: 'adminListConfig',
            config: {search: search},
        } );
        getUsers();
    };
    */

    const history = useHistory();

    return (
        <div className={showSidebar && window.innerWidth <= 700 ? 'ul-div-background bg-mt-10' : 'ul-div-background'}>
            <p className="ul-p-name">{name}</p>
            <div className="ul-div-section">

                <div className="vu-head-sect">
                    <div className='al-header vu-header'>
                        <NavBefore event={()=>history.goBack()}/>
                        <div className="ul-p-title"
                            title={`
                                ${selectedAffiliate?.firstName} ${selectedAffiliate?.lastName
                                }\nDNI: ${selectedAffiliate?.dni
                                }\nPLAN: ${selectedAffiliate?.plan
                                }\nN Afiliado: ${selectedAffiliate?.affiliateNumber
                                }\nEstado: ${selectedAffiliate?.state}
                            `}
                        >
                            ATENCIONES: {selectedAffiliate?.firstName} {selectedAffiliate?.lastName}
                            <hr id="id-hr"/>
                        </div>
                    </div>
                    <div className="ul-div-serchCont vu-form">
                        <div className="ul-div-searchbar">
                            <input
                                placeholder="Atenciones"
                            />
                            <button type='submit'><img src={icSearch} alt={'search'}/></button>
                        </div>
                    </div>
                </div>

                <div className="ul-div-sect-table">
                    { getAttentionsState?.success?
                        <table className="ul-div-table">
                            <TableHeader listData={listData} />
                            <tbody>
                            {
                                attentions?.total <= 0 ?
                                <tr><td colSpan={100} ><CustomAlert text='administradores' /></td></tr> :
                                attentions?.results && attentions?.results.map((item, index) =>
                                    <TableRow key={index} listData={listData} data={item} />,
                                )
                            }
                            </tbody>
                        </table> :
                    getAttentionsState?.loading?<Loading className="ul-div-sect-table" />:
                        <CustomAlert text={'afiliados' || String(getAttentionsState?.error)} severity='error' />
                    }
                </div>

                <div className="ul-div-bottom">
                    <ListPaginator pageQuantity={pageQuantity} currentPage={attentionsListConfig?.page} setCurrentPage={setCurrentPage} />
                </div>

            </div>
            {showModal && (
                <AttentionDetailsModal
                    showModal={showModal}
                    handleClose={()=>setShowModal(false)}
                    handleClick={()=>setShowModal(false)}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
  name: localStorage.getItem('name'),
  title: state.home.title,
  attentions: state.attentions.attentions,
  attentionsListConfig: state.attentions.attentionsListConfig,
  getAttentionsState: state.attentions.getAttentionsState,
  selectedAffiliate: state.attentions.selectedAffiliate,
  showSidebar: state.common.showSidebar,
});

const mapDispatchToProps = (dispatch) => ({
  switchOfUser: (name) => dispatch(actions.home.switchOfUser(name)),
  getAttentions: (body) => dispatch(actions.attentions.getAttentions(body)),
  setListConfig: (body) => dispatch(actions.attentions.setListConfig(body)),
  setSelectedAttention: (attention) => dispatch(actions.attentions.setSelectedAttention(attention)),
});

AttentionList.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(AttentionList);
